<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	class="normalDuotoneHeaderIcon"
	[headerText]="T.DELETE_MEDIA_DIALOG_TITLE | translate"
	[overflowHandledByChild]="true"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-trash-alt'}"
>
	<div dialogContent class="contentWrapper">
		@if (loading) {
			<sim-component-loading-container
				[errorLoading]="!loading && !data"
				[errorMessage]="T.DELETE_MEDIA_DIALOG_ERROR_LOADING_AFFECTED_ENTITIES | translate"
				[isLoading]="loading"
				[loadingIcon]="'fad fa-sync'"
				[loadingMessage]="T.DELETE_MEDIA_DIALOG_LOADING | translate"
			/>
		}

		@if (!loading) {
			<mat-icon class="waterSign"> warning </mat-icon>
			<p class="infoText">
				{{ T.DELETE_MEDIA_DIALOG_WARNING | translate: {name: data.mediaName} }}
			</p>
			<p class="infoText">
				{{ T.DELETE_MEDIA_DIALOG_INFO | translate: {total: totalAffectedEntities} }}
			</p>
			@if (affectedMediaSets.length) {
				<div class="mediaListContainer">
					<h2>{{ T.DELETE_MEDIA_DIALOG_MEDIA_SETS | translate }}</h2>
					<ul class="mediaList">
						@for (item of affectedMediaSets; track item) {
							<li>
								<div class="mediaItem">
									<div class="name">{{ item.name }}</div>
								</div>
							</li>
						}
					</ul>
				</div>
			}
			@if (affectedScenarios.length) {
				<div class="mediaListContainer">
					<h2>{{ T.DELETE_MEDIA_DIALOG_SCENARIOS | translate }}</h2>
					<ul class="mediaList">
						@for (item of affectedScenarios; track item) {
							<li>
								<div class="mediaItem">
									<div class="name">{{ item.name }}</div>
								</div>
							</li>
						}
					</ul>
				</div>
			}
			@if (affectedVogSets.length) {
				<div class="mediaListContainer">
					<h2>
						{{ T.DELETE_MEDIA_DIALOG_AUDIO_TO_ROOM_SETS | translate }}
					</h2>
					<ul class="mediaList">
						@for (item of affectedVogSets; track item) {
							<li>
								<div class="mediaItem">
									<div class="name">{{ item.name }}</div>
								</div>
							</li>
						}
					</ul>
				</div>
			}
			@if (affectedVtpSets.length) {
				<div class="mediaListContainer">
					<h2>{{ T.DELETE_MEDIA_DIALOG_VTP_SETS | translate }}</h2>
					<ul class="mediaList">
						@for (item of affectedVtpSets; track item) {
							<li>
								<div class="mediaItem">
									<div class="name">{{ item.name }}</div>
								</div>
							</li>
						}
					</ul>
				</div>
			}
		}
	</div>

	<ng-container actions>
		<sim-button
			(onClick)="close({action: 'cancel'})"
			[color]="'accent'"
			[icon]="{fontSet: 'fal', fontIcon: 'fa-times'}"
			[label]="T.BUTTON_CANCEL"
		/>

		<sim-button
			[color]="'warn'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-trash'}"
			[label]="T.DELETE_MEDIA_DIALOG_DELETE_BUTTON"
			(onClick)="close({action: 'ok'})"
		/>
	</ng-container>
</sim-basic-material-dialog>
